import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import api from '../api';

export default function SetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) navigate('/login');
  }, [token, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return setError('Wachtwoorden komen niet overeen');
    if (password.length < 8) return setError('Wachtwoord moet minstens 8 tekens bevatten');
    setError('');
    setLoading(true);
    try {
      const { data } = await api.post('/api/auth/set-password', { token, password });
      localStorage.setItem('token', data.token);
      navigate(data.role === 'admin' ? '/admin' : '/');
    } catch (err) {
      setError(err.response?.data?.error || 'Er ging iets mis. Vraag een nieuwe uitnodiging.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="quiz-container">
      <div className="quiz-card start-card" style={{ maxWidth: 440 }}>
        <h1>HVAC Quiz</h1>
        <p className="subtitle">Wachtwoord instellen</p>
        <form onSubmit={handleSubmit} className="auth-form">
          {error && <div className="error-banner">{error}</div>}
          <div className="form-group">
            <label>Nieuw wachtwoord</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Min. 8 tekens"
              required
              autoFocus
            />
          </div>
          <div className="form-group">
            <label>Bevestig wachtwoord</label>
            <input
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              placeholder="Herhaal wachtwoord"
              required
            />
          </div>
          <button className="btn btn-primary btn-large" type="submit" disabled={loading}>
            {loading ? 'Opslaan...' : 'Wachtwoord instellen'}
          </button>
        </form>
      </div>
    </div>
  );
}
